import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { X, ZoomIn } from "lucide-react";
import "./ImagePreviewModal.css";

interface ImagePreviewModalProps {
  src: string | null;
  altText?: string;
  onClose: () => void;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  src,
  altText = "Image Preview",
  onClose,
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    if (src) {
      window.addEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "hidden";
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [src, onClose]);

  if (!src) return null;

  return ReactDOM.createPortal(
    <div className="iq-image-preview-overlay" onClick={onClose}>
      <div
        className="iq-image-preview-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="iq-image-preview-header">
          <div className="iq-image-preview-title">
            <ZoomIn size={18} color="#0d6e5b" />
            <span>Image Preview</span>
          </div>
          <button
            type="button"
            className="iq-image-preview-close-btn"
            onClick={onClose}
            title="Close Preview"
          >
            <X size={20} />
          </button>
        </div>

        <div className="iq-image-preview-body">
          <img src={src} alt={altText} className="iq-image-preview-img" />
        </div>

        <div className="iq-image-preview-footer">
          <button
            type="button"
            className="iq-image-preview-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ImagePreviewModal;
